import { kebabCase } from "lodash";
import Loader from "components/Loader";
import useGlobalContext from "hooks/globalData";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { OrganizationAttributeTypeRequest } from "services/KnowfullyAdminClient";
import contextStore from "stores/contextStore";
import { AttributeList } from "./AttributeList";

const AttributeListWrapper = () => {
  const { code } = useParams<{ code: string }>();
  const { attributeService } = useGlobalContext();
  const { organizationId } = contextStore.useState();

  const isAttributeManagementAvailable = true;

  const request = OrganizationAttributeTypeRequest.fromJS({
    sortField: "name",
    organizationId,
    parameters: { isAttributeManagementAvailable },
  });

  const { data, isLoading } = useQuery(
    ["getOrganizationAttributeTypes", request],
    () => attributeService.getOrganizationAttributeTypes(request)
  );

  if (isLoading) {
    return <Loader />;
  }

  const organizationAttributeTypes = data?.data || [];
  const matchingType = organizationAttributeTypes.find(
    (oat) => kebabCase(oat.attributeType?.codeConstant ?? "") === code
  );

  if (!matchingType) {
    return <div>Attribute type not found</div>;
  }

  return <AttributeList organizationAttributeTypeArgument={matchingType} />;
};

export default AttributeListWrapper;
